module.exports = __webpack_public_path__ + "static/media/legendaryChest__top--open.56f0044d.png";